/**
 * @changelog
 *
 * 2026-10-09 (0.1.0) (jhoward)
 *   - Add the header's expanded and collapsed heights, and the scroll distance between them. AppHeader.vue draws the
 *     header from the first two; the router scrolls a new page to the third, so the patron lands with the header just
 *     collapsed instead of seeing all of it on every navigation.
 *
 * 2026-10-09 (0.2.0) (jhoward)
 *   - Add getHeaderNaturalTop() and getHeaderCollapsedScroll(). The header is sticky, not fixed, so it scrolls up with
 *     the page until it reaches the top and only then collapses; counting from scroll 0 made it move at twice the
 *     page's speed, and made the router's landing point fall short of fully collapsed.
 */

/** The height of the header at the top of the page, in px. */
export const HEADER_MAX_HEIGHT = 200;

/** The height of the header once it has collapsed, in px. */
export const HEADER_MIN_HEIGHT = 64;

/** How far the page has to be scrolled for the header to be fully collapsed, in px. */
export const HEADER_COLLAPSE_DISTANCE = HEADER_MAX_HEIGHT - HEADER_MIN_HEIGHT;

/**
 * The page y, in px, at which the header sits when nothing has scrolled: the bottom of the property chrome above it, or
 * 0 where there is none. The header is position: sticky (src/main.css), so it travels with the page until it reaches the
 * top of the viewport, and only from then on is it collapsing. Measured, not assumed, because the chrome is a different
 * height on each property and at each width.
 */
export function getHeaderNaturalTop(): number {
  const chrome = document.querySelector('.site_shell--header');

  return chrome ? Math.max(0, Math.round(chrome.getBoundingClientRect().bottom + window.scrollY)) : 0;
}

/** The scroll position at which the header has stuck and finished collapsing: the least it ever needs to show. */
export function getHeaderCollapsedScroll(): number {
  return getHeaderNaturalTop() + HEADER_COLLAPSE_DISTANCE;
}
